<template>
  <div
    class="wrapper row no-margin"
    style="height: 100%;display: flow-root;">

    <header class="row align-items-center no-margin">
      <div class="col">
        <button
          class="btn no-bg"
          @click="setPosSection('choose-product')">
          <i class="fas fa-times"/>
        </button>
      </div>
    </header>

    <div class="col-12 mt-3 mb-1 status">
      {{ $t('message.diningoptions') }}
    </div>
    <ul class="col-12 no-padding items">
      <li
        v-if="diningName"
        class="row no-margin item text-danger"
        @click="onDeselectDining()">
        <div class="col">
          <i
            class="fas fa-ban"
            style="margin-right: 7px;margin-left: 3px;font-size: 13px;"/>
          {{ $t('message.deselected') }}
        </div>
      </li>
      <li
        v-for="(item, index) in diningOptions"
        :key="index"
        class="row no-margin item"
        @click="onSelectDining(item.name)"
      >
        <div class="col container-dining">
          <div class="dining-icon">
            <i
              :class="[item.icon]"
            />
          </div>
          <span>
            {{ item.text }}
          </span>
        </div>
        <div class="col text-right"/>
      </li>
    </ul>
  </div>
</template>

<script>
import diningListMixin from '@/mixins/pos/diningList'

export default {
  mixins: [diningListMixin],
}
</script>

<style scoped>
.wrapper ul.items {
  overflow: auto;
}
.wrapper ul.items li.item {
  padding: 10px 15px;
  background: #fff;
  border-bottom: solid 1px #F2F2F2;
  cursor: pointer;
}
.wrapper ul.items li.item .col {
  padding: 0;
}
.wrapper ul.items li.item i.fa-circle {
  font-size: 8px;
  position: relative;
  top: -2px;
  margin-right: 12px;
  margin-left: 6px;
}
.wrapper ul.items li.item.available i.fa-circle {
  color: #8BC34A;
}

.container-dining {
  display: flex;
}
.container-dining .dining-icon {
  width: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/pos/sale/main/include/DiningList.vue